// extracted by mini-css-extract-plugin
export default {"dialog":"G_cYwH9oIs322XMl","dialogWhenAddressFormVisible":"aWt7IgokX7AUGFS0 G_cYwH9oIs322XMl","columnsContainer":"sdTFXESGCXQFL8rV","column":"q5hNUr57W06Zjj8Y"};